<div class="privacy-container">
    <h1 class="privacy-main-title">KGA Android App Privacy Policy</h1>
    <div class="privacy-divider"></div>
    <h2 class="privacy-section-title">PRIVACY POLICY</h2>

    <h2 class="privacy-section-title">1. Use and Applicability</h2>
    <p class="privacy-text">
        This Privacy Policy applies to Karnataka Golf Association (KGA) ("KGA", "We", "Our", or "Us") and governs
        the privacy of users who access or use KGA’s mobile application and website (www.kga.in) (collectively
        referred to as the "Platform").
    </p>

    <p class="privacy-text">
        The information available on the Platform is for general informational purposes only and does not constitute
        a legal offering. KGA reserves the right to modify, amend, add or remove any part of this Privacy Policy at
        its sole discretion, without prior notice. By accessing or using our Platform or services, you confirm that
        you have read, understood, and agreed to the terms of this Privacy Policy.
    </p>

    <p class="privacy-text">
        This Privacy Policy does not constitute a contract and does not create any legal rights or obligations
        beyond those provided under the applicable law/s.
    </p>

    <p class="privacy-text">
        KGA respects the privacy of its users and is committed to protecting it in all respects.
    </p>

    <p class="privacy-text">
        Information collected by KGA includes: (a) information voluntarily provided by users, and (b) information
        automatically collected during navigation and usage of the Platform.
    </p>

    <p class="privacy-text">
        This Privacy Policy outlines how user data is collected, stored, processed and protected by KGA.
    </p>

    <p class="privacy-text">
        By visiting, accessing, or using the Platform, users explicitly consent to the collection, storage,
        processing, use, disclosure and transfer of their personal information in accordance with this Privacy
        Policy.
    </p>

    <p class="privacy-text">
        This Privacy Policy applies only to information collected through the Platform and does not apply to
        information collected offline or through any other medium.
    </p>

    <h2 class="privacy-section-title">2. Collection of User Information</h2>

    <p class="privacy-text">
        We collect information from users when they register, log in, or complete our forms on our Platform. The
        information collected may include, but is not limited to:
    </p>

    <ul class="privacy-list">
        <li>Name of the user</li>
        <li>Contact details (mobile number)</li>
        <li>Address</li>
        <li>Email ID</li>
        <li>Any other information voluntarily provided by the user & in the form</li>
    </ul>

    <h2 class="privacy-section-title">3. Use of Cookies</h2>

    <p class="privacy-text">
        Cookies are small data files stored on the user’s device by the browser. Cookies help us understand user
        preferences and enhance user experience by enabling uninterrupted service. Cookies may be placed on the
        user’s device when accessing the Platform.
    </p>

    <p class="privacy-text">
        The information collected through cookies is anonymous and is not linked to any personally identifiable
        information provided by the user.
    </p>

    <h2 class="privacy-section-title">4. Use of User Information</h2>

    <p class="privacy-text">Information collected from users may be used for the following purposes:</p>

    <ul class="privacy-list">
        <li>To personalize user experience</li>
        <li>To improve the Platform and its functionality</li>
        <li>To improve customer service</li>
        <li>To send periodic communications, subject to user consent</li>
    </ul>

    <p class="privacy-text">
        The email address provided by the user may be used to send updates related to user requests, transactions or
        services, along with occasional information about KGA news, updates and promotions.
    </p>

    <p class="privacy-text">
        <b>Opt-out:</b> Users may unsubscribe from future communications at any time by responding to the received
        communication or contacting us directly.
    </p>

    <h2 class="privacy-section-title">5. Protection of User Information</h2>

    <p class="privacy-text">
        We implement reasonable administrative, technical and physical security measures to safeguard user personal
        information. These measures include, but are not limited to, password-protected systems and restricted
        access to databases.
    </p>

    <h2 class="privacy-section-title">6. Disclosure of Information to Third Parties</h2>

    <p class="privacy-text">
        KGA does not sell, trade or rent user personal information to third parties.
    </p>

    <p class="privacy-text">
        User information may be shared with trusted third-party service providers who assist in operating the
        Platform, conducting business activities, or servicing users, provided such parties agree to maintain
        confidentiality.
    </p>

    <p class="privacy-text">
        We may also disclose user information if:
    </p>

    <ul class="privacy-list">
        <li>Required by applicable law or regulatory authorities</li>
        <li>Necessary to enforce our rights or respond to legal proceedings</li>
        <li>Required to provide services requested by the user</li>
    </ul>

    <h2 class="privacy-section-title">7. Limitation of Liability</h2>

    <p class="privacy-text">
        While KGA takes reasonable steps to protect user information, KGA shall not be held liable for any loss,
        damage or claims arising from unauthorised access, misuse, theft or corruption of data arising due to
        circumstances beyond its reasonable control.
    </p>

    <h2 class="privacy-section-title">8. Marketing and Communication</h2>

    <p class="privacy-text">We may use user information for marketing and communication purposes, including:</p>

    <ul class="privacy-list">
        <li>Informing users about promotions, offers, and events</li>
        <li>Sending push notifications via the mobile application and the like</li>
        <li>Communicating new features or services</li>
    </ul>

    <p class="privacy-text">
        Users may choose to opt in or opt out of marketing communications at any time. By submitting personal
        information, users authorize KGA to contact them via call, SMS, email, or WhatsApp regarding services,
        updates, or offers, even if the number is registered under DND, subject to applicable laws.
    </p>

    <h2 class="privacy-section-title">9. Rights of Data Subjects</h2>

    <p class="privacy-text">Subject to applicable laws, users have the following rights:</p>

    <ul class="privacy-list">
        <li><b>Right to be informed:</b> To receive clear information on how personal data is used.</li>
        <li><b>Right of access:</b> To request access to one's own personal data held by KGA.</li>
        <li><b>Right to rectification:</b> To request correction of inaccurate or incomplete data.</li>
        <li><b>Right to erasure:</b> To request deletion of personal data, subject to legal and contractual
            obligations.</li>
        <li><b>Right to data portability:</b> To obtain and reuse personal data across services.</li>
        <li><b>Right to object:</b> To object to processing of personal data, including for direct marketing
            purposes.</li>
        <li><b>Right to withdraw consent:</b> To withdraw consent for processing of personal data at any time, with
            immediate effect for future processing.</li>
    </ul>

    <p class="privacy-text">
        KGA may update this Privacy Policy periodically. Any material changes will be communicated as required by
        law. Continued use of the Platform constitutes acceptance of the updated Privacy Policy.
    </p>

    <h2 class="privacy-section-title">10. Contact Information</h2>

    <div class="privacy-contact">
        <div class="privacy-contact-text"><b>Karnataka Golf Association (KGA)</b></div>
        <div class="privacy-contact-text">No. 1, Golf Avenue, Kodihalli</div>
        <div class="privacy-contact-text">Bengaluru, Karnataka – 560008</div>
        <div class="privacy-contact-text">Phone: 080-4009-000</div>
        <div class="privacy-contact-email">Or email to: it&#64;kga.in</div>
    </div>
</div>